import React from 'react';
import {motion} from 'framer-motion';

const BonusSection=({timeLeft,openCheckoutPopup})=> {
  const bonuses=[
    {
      title: "Diwali Workshop",
      value: "₹4,999",
      description: "Step-by-step guide to implement top 20 sales boosters.",
      icon: "🎯"
    },
    {
      title: "WhatsApp & Email Automation Templates",
      value: "₹3,999",
      description: "Ready-to-use flows to convert leads automatically.",
      icon: "⚡"
    },
    {
      title: "Free Software Access",
      value: "₹5,999",
      description: "Access tools for CRM + automation to apply strategies immediately.",
      icon: "🛠️"
    },
    {
      title: "Bulk WhatsApp Tutorial",
      value: "₹6,999",
      description: "Send up to 5 lakh messages safely and effectively.",
      icon: "📱"
    },
    {
      title: "Lead Generation Strategy Playbook",
      value: "₹3,499",
      description: "Learn to fill your sales funnel with hot leads every day.",
      icon: "🎯"
    }
  ];

  const totalValue=bonuses.reduce((sum, bonus)=> {
    return sum + parseInt(bonus.value.replace('₹', '').replace(',', ''));
  }, 0);

  return (
    <section id="bonuses" className="py-16 bg-gradient-to-br from-purple-50 to-orange-50">
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center mb-12"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Act Within 15 Minutes & Get These <span className="gradient-text">Diwali Bonuses FREE</span>
            🎁
          </h2>
          <div className="timer-glow text-white px-6 py-3 rounded-xl inline-flex items-center space-x-2">
            <span>⏰</span>
            <span className="font-bold">Timer: {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}</span>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {bonuses.map((bonus, index)=> (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-2xl shadow-lg card-hover gold-glow"
              initial={{opacity: 0, y: 30}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.6, delay: index * 0.1}}
              viewport={{once: true}}
            >
              <div className="text-center mb-4">
                <div className="text-4xl mb-2">{bonus.icon}</div>
                <div className="bg-gradient-to-r from-orange-400 to-red-500 text-white px-3 py-1 rounded-full text-sm font-semibold mb-2">
                  {bonus.value} Value
                </div>
              </div>
              <h3 className="font-bold text-xl text-gray-800 mb-3 text-center">
                Bonus #{index + 1} – {bonus.title}
              </h3>
              <p className="text-gray-600 text-center">{bonus.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="bg-white p-8 rounded-3xl shadow-2xl border-4 border-gold text-center"
          initial={{opacity: 0, scale: 0.9}}
          whileInView={{opacity: 1, scale: 1}}
          transition={{duration: 0.6, delay: 0.5}}
          viewport={{once: true}}
        >
          <div className="mb-6">
            <div className="text-2xl font-bold text-gray-800 mb-2">
              💰 Total Bonus Value: <span className="gradient-text">₹{totalValue.toLocaleString()}</span> FREE
            </div>
            <div className="text-3xl font-bold gradient-text">
              Your Price Today: ₹97 Only
            </div>
          </div>
          <button 
            onClick={openCheckoutPopup}
            className="glow-button text-white px-8 py-4 rounded-xl font-bold text-lg w-full md:w-auto"
          >
            🔥 Yes! I Want the eBook + Bonuses →
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default BonusSection;